import { userReducer } from './user';
import type {
  GlobalContextAction,
  GlobalContextReducerState,
  UserAction
} from './types';

export const rootReducer = (
  { user }: GlobalContextReducerState,
  action: GlobalContextAction
): GlobalContextReducerState => ({
  user: userReducer(user, action as UserAction)
});
